import React from 'react';
import NewVSLastStep from './NewVSLastStep';

const NewVSLastStepContainer = ({ formikProp }) => {
  return <NewVSLastStep formikProp={formikProp} />;
};

export default NewVSLastStepContainer;
